<template lang="pug">
  .footer#footer
    .container
        .footer__logoWP
            img.footer__logo(src=`../assets/images/footer_logo.png`, alt="")
        .footer__content
            .footer__mail
                .footer__mailTitle {{ tr.supportTitle }}
                .footer__mailTitle__item
                  span.footer__mailAddres__text {{tr.forUsaPartners}}
                  a.footer__mailAddres(href='mailto:support.usa@wwp.capital' target="_blank") support.usa@wwp.capital
                .footer__mailTitle__item
                  span.footer__mailAddres__text {{tr.forOthersPartners}}
                  a.footer__mailAddres(href='mailto:support@wwp.capital' target="_blank") support@wwp.capital
            .footer__data.footer__address
                <span class='footer__data_500'>APIN FORTE LTD {{ tr.addres }}</span> 5 Spyrou Kyprianou, 2nd floor, office 202,
                |4001 Limassol, Mesa Geitonia, Cyprus<br>
                <span class='footer__data_500'>licensed by </span>
                <span class='footer__data_500'>FIMOLVIA HOLDINGS LTD {{ tr.addres }}</span>
                <span> 5 Spyrou Kyprianou, 2nd floor, office 202, 4001 Limassol, Mesa Geitonia, Cyprus</span>
            .footer__border
            .footer__social
                .footer__socialTitle
                    span(v-html='tr.social')
                    br
                    br
                    .footer__socialIcons(v-if="!englishVersion && !mexicoVersion")

                        a(href="https://vk.com/wwpcapitalofficial" target="_blank"  style="padding-left: 2px;")
                            include ../assets/images/svg/vk.svg
                        a(href="https://www.facebook.com/official.WWPCapital/" target="_blank" )
                            include ../assets/images/svg/fb.svg
                        a(href="https://www.instagram.com/wwpcapital.official/" target="_blank" style="padding-top: 3px;")
                            include ../assets/images/svg/in.svg
                        a.icon-you(href="https://www.youtube.com/channel/UCcBOlmGCJu_L8A9xjOYthkQ" target="_blank" style="padding-left: 2px;")
                            include ../assets/images/svg/yt.svg

                    .footer__socialIcons(v-if="englishVersion || mexicoVersion" style="justify-content : flex-start")

                        a(href="https://www.facebook.com/SwitplanetGlobal-110347607500964/" target="_blank" )
                            include ../assets/images/svg/fb.svg
                        a(href="https://www.instagram.com/myswitplanet.global/" target="_blank" style="padding-top: 3px;")
                            include ../assets/images/svg/in.svg
                        a(href="https://twitter.com/SwitplanetG" target="_blank" style="padding-top: 3px;margin-left: 3px")
                          include ../assets/images/svg/tw.svg
                        a(:href="lang === 'es' ? 'https://youtube.com/@GLOBALMEXICO' : 'https://www.youtube.com/c/MYSWITPLANET'" target="_blank" style="padding-top: 3px;margin-left: 3px")
                          include ../assets/images/svg/yt.svg
            .footer__border
            .footer__border-mobile
            .footer__data
                span(class='footer__data_500' v-html="tr.agreementsTitle")
                br
                router-link(:to="getS3Link('LicenseAgreement')" style="padding-top: 3px;text")
                    span(v-html="tr.license")
                br
                router-link(:to="getS3Link('Privacy')" style="padding-top: 3px;")
                    span(v-html="tr.privacyPolicy")
                br
                router-link(:to="getS3Link('Cookies')" style="padding-top: 3px;")
                    span(v-html="tr.cookiePolicy")
                br
                router-link(:to="getS3Link('Rules_of_Partners')" style="padding-top: 3px;")
                    span(v-html="tr.rulesOfPartner")
                br
                router-link(:to="getS3Link('Delivery_and_Refund')" tag="a" style="padding-top: 3px;text"  v-if="englishVersion")
                  span Delivery and Refund Policy

    portal-target(name="modal")
</template>
<!--a(href="https://t.me/wwpcapital" target="_blank" )-->
<!--include ../assets/images/svg/telegram.svg-->
<!--//- img(src="assets/img/svg/6.svg")-->

<script>
import langOps from '@/mixins/langOps'
export default {
  data () {
    return {
      section: 'footer'
    }
  },
  mixin: [langOps],
  methods: {
    getS3Link (name) {
      return '/docs/' + this.lang + '/' + name
    }
  }
}
</script>

<style lang="scss">
  .footer {
    a {
      color: grey;
    }
    position: relative;
    background: #050505;
    color: #fff;
    padding-top: 88px;
    padding-bottom: 130px;
    overflow-x: hidden;

    &::before {
      content: '';
      width: 65%;
      height: 100%;

      position: absolute;
      top: -120px;
      right: -30px;

      // background: url("/img/ww_mobile.png") 100% 100% no-repeat;
      background-size: contain;
    }

    @media (max-width: 480px) {
      &::before {

        width: 220%;
        height: 100%;

        position: absolute;
        top: -240px;
        right: -480px;

        background: none;
        background-size: cover;
        filter: invert(100%);
      }
      padding-top: 50px;
      padding-bottom: 70px;
    }

    &__border-mobile {
      display: none;
      @media (max-width: 1024px) {
        display: block;
        margin-top: 30px;
        margin-bottom: 30px;
        width: 100%;
        height: 1px;
        border-bottom: dotted 2px rgba(140, 144, 149, 0.3);
      }
    }

    &__border {
      position: relative;
      width: 2px;
      height: 100px;
      //   opacity: 0.3;
      //   border: solid 1.5px #8c9095;
      background-color: transparent;
      border-left: 2px dotted rgba(140, 144, 149, 0.3);
      z-index: 2;
      @media (max-width: 1024px) {
        display: none;
      }
    }

    &__content {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      padding-left: 50px;
      padding-right: 50px;
      flex-wrap: wrap;

      // opacity: 0.3;
      border-left: dotted 2px rgba(140, 144, 149, 0.3);
      border-right: dotted 2px rgba(140, 144, 149, 0.3);

      @media (max-width: 1024px) {
        margin-left: 0;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border: none;

        padding-left: 0;
        padding-right: 0;
      }

    }

    &__logo {
      width: 183px;
      margin-bottom: 28px;
      opacity: 0.7;

      &WP {
        position: relative;
        margin-bottom: 58px;
        border-bottom: dotted 2px rgba(140, 144, 149, 0.3);
        @media (max-width: 1024px) {
          display: flex;
          justify-content: center;
          border-bottom: solid 2px rgba(140, 144, 149, 0.3);
          align-items: center;
          margin-bottom: 30px;
        }
      }

    }

    &__mail {
      color: #47494e;

      &Title {

        font-size: $fz_s;
        letter-spacing: 0.1px;
        margin-bottom: .5rem;
      }

      &Addres {
        font-size: $fz_s;
        line-height: 1.5;
        letter-spacing: 0.2px;
        text-decoration: underline;
        color: #47494e;
        -webkit-transition: color .3s;
        -moz-transition: color .3s;
        -ms-transition: color .3s;
        -o-transition: color .3s;
        transition: color .3s;
        &:hover{
          color: #fff
        }
      }

      @media (max-width: 1024px) {

        &Title {
          margin-bottom: 0;
        }
      }
    }

    &__data {
      color: #47494e;
      line-height: 1.57;
      letter-spacing: 0.1px;

      &_500 {
        font-weight: 500;
      }

      @media (max-width: 1024px) {

      }
    }
    &__address{
      order: 4;
      width: 100%;
      margin-top: 30px;
      @media(max-width: 1024px){
        order: inherit;
        &::before{
          content: '';
          display: block;
          width: 100%;
          margin-bottom: 30px;
          height: 1px;
          border-bottom: dotted 2px rgba(140, 144, 149, 0.3);
        }
      }
    }

    &__social {
      display: flex;
      align-items: center;

      &Title {
        margin-right: 44px;
        letter-spacing: 0.1px;
        color: #9a9ea8;

        @media (max-width: 1024px) {
          display: none;
        }
      }

      &Icons {
        display: flex;
        align-items: center;
        justify-content: space-between;

        width: 130px;

        @media (max-width: 1024px) {
          justify-content: space-evenly;
          width: 100%;
        }
      }

      .icon-you{
        svg{
          width: 31px;
          height: 31px;
        }
      }

      &Icon {
        padding-left: 2px;
        padding-right: 2px;
        width: 25px;
        fill: #82868b;

        &:nth-child(1) {
        }

        &:nth-child(3) {
          margin-left: 7px;
        }

        @media (min-width: 1025px) {
          &:hover {
            fill: #fe740d;
          }
        }
      }

      @media (max-width: 1024px) {
        width: 100%;
        justify-content: center;
      }
    }
  }
  .footer__mailTitle__item{
    margin-bottom: .5rem;
    .footer__mailAddres__text{
      display: block;
      font-size: 14px;
    }
  }
</style>
